import { render, staticRenderFns } from "./AdItems.vue?vue&type=template&id=a3acfb56"
import script from "./AdItems.vue?vue&type=script&lang=js"
export * from "./AdItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports